var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"app-container"}},[_c('keep-alive',[_c(_vm.currentVersionTemplate,{ref:"app",tag:"component"})],1),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gc-highlight-element"},[_c('div',{staticClass:"gc-highlight-element__wrapper"},[_c('div',{staticClass:"gc-highlight-element__content"})])])
}]

export { render, staticRenderFns }